import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { getTheme } from '_style';

import { TChatOptions } from '_types/options';

import AdaChat from '_modules/chat/components';

const queryClient = new QueryClient();

interface Props {
  options: TChatOptions;
}

const App = ({ options }: Props) => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={getTheme(options.zIndex)}>
      <AdaChat name={options.name} />
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
